/**
 * Shared Tailwind class constants for the Funnels module.
 * Uses fn-* design tokens mapped to --fn-* CSS custom properties.
 *
 * Usage: import { inputClass, labelClass, selectClass } from '../../styles/class-utils'
 */

/** Standard text input — full width, themed border, focus ring */
export const inputClass =
  'w-full px-3 py-2 border border-fn-border rounded-md text-sm text-fn-text bg-fn-input ' +
  'focus:outline-none focus:ring-2 focus:ring-fn-border-focus focus:border-transparent transition-all ' +
  'placeholder:text-fn-text-muted'

/** Standard select input — same as input + caret hidden for custom chevron */
export const selectClass =
  'w-full px-3 py-2 border border-fn-border rounded-md text-sm text-fn-text bg-fn-input ' +
  'focus:outline-none focus:ring-2 focus:ring-fn-border-focus focus:border-transparent transition-all ' +
  'appearance-none'

/** Standard textarea — same as input + resize control */
export const textareaClass =
  'w-full px-3 py-2 border border-fn-border rounded-md text-sm text-fn-text bg-fn-input ' +
  'focus:outline-none focus:ring-2 focus:ring-fn-border-focus focus:border-transparent transition-all ' +
  'placeholder:text-fn-text-muted resize-none'

/** Form label */
export const labelClass = 'block text-sm font-medium text-fn-text mb-1.5'

/** Modal backdrop overlay */
export const backdropClass = 'fixed inset-0 bg-black/50 animate-fade-in'

/** Modal / dialog card container */
export const dialogCardClass =
  'relative z-10 w-full bg-fn-card rounded-lg shadow-fn-modal border border-fn-border animate-scale-in'

/** Dialog header row (title + close button) */
export const dialogHeaderClass = 'flex items-center justify-between px-6 py-4 border-b border-fn-border'

/** Dialog footer row (action buttons) */
export const dialogFooterClass = 'flex justify-end gap-3 px-6 py-4 border-t border-fn-border'

/** Dialog title */
export const dialogTitleClass = 'text-lg font-semibold text-fn-text'

/** Context menu / dropdown container */
export const dropdownMenuClass =
  'bg-fn-card rounded-lg shadow-fn-dropdown border border-fn-border py-1 z-50 animate-scale-in'

/** Context menu / dropdown item */
export const dropdownItemClass =
  'w-full text-left px-3 py-2 text-sm hover:bg-fn-hover transition-colors flex items-center gap-2'

/** Table header row background */
export const tableHeaderBgClass = 'bg-fn-muted'

/** Table row hover */
export const tableRowHoverClass = 'hover:bg-fn-hover transition-colors cursor-pointer'

/** Table border between rows */
export const tableBorderClass = 'border-b border-fn-border'
